__webpack_require__.p = "/o/webpack-dynamic-include/assets/";